import Blur from '@assets/backgrounds/blur-bottom.png';
import { Button } from '@lib/core/src/components/Buttons';
import palette from '@lib/core/src/theme/palette';
import { List, Typography, styled, Stack } from '@mui/material';

import { GenerateButtonStyle } from '@/pages/GoalsPage/components/StrategicPlanStyles';

export const Container = styled(Stack)({
  width: '100%',
  height: '100%',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  overflowY: 'auto',
  backgroundImage: `url(${Blur})`,
  backgroundSize: 'cover',
  backgroundPosition: 'bottom',
  backgroundRepeat: 'no-repeat'
});

export const MarginStack = styled(Stack)({
  margin: 'auto',
  marginRight: '0',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '90%',
  height: '80%',
  gap: '3vw',
  flexWrap: 'wrap'
});

export const Title = styled(Typography)({
  fontSize: '24px',
  fontWeight: 600,
  color: palette.black,
  maxWidth: '400px'
});

export const Text = styled(Typography)({
  fontSize: '13px',
  fontWeight: 400,
  color: palette.grey[500]
});

export const HalfContainer = styled(Stack)({
  width: 'calc(50% - 1.5vw)',
  height: '100%',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: '300px',
  padding: '20px 0'
});

export const IntegrationsContainer = styled(HalfContainer)({
  borderRadius: 16,
  border: `1px solid ${palette.grey[200]}`,
  background: palette.white,
  boxShadow: '0 4px 41.2px 12px rgba(0, 0, 0, 0.06)',
  alignItems: 'center'
});

export const Ul = styled(List)({
  margin: 0,
  paddingLeft: '20px',
  listStyleType: 'disc',
  fontSize: '13px',
  color: palette.grey[500],
  fontWeight: 400,
  lineHeight: '20px'
});

export const ContinueButton = styled(Button)({
  marginTop: '40px'
});

export const GenerateButton = styled(GenerateButtonStyle)({
  marginTop: '40px'
});

export const ProgbarContainer = styled(Stack)({
  width: '100%',
  height: '100px',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center'
});
